var map = {
	"./ComServiceIcon.svg": 4125,
	"./ConsumerIcon.svg": 9953,
	"./ConsumerStaplesIcon.svg": 6275,
	"./DefaultIcon.svg": 2658,
	"./FinancialsIcon.svg": 7613,
	"./HealthCareIcon.svg": 2958,
	"./InductryIcon.svg": 2963,
	"./InformationTechnologyIcon.svg": 3131,
	"./MaterialIcon.svg": 948,
	"./RealEstateIcon.svg": 7084,
	"./UtilitiesIcon.svg": 4244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8989;